import { Controller } from "@hotwired/stimulus"

// DominiDialog di pages/Grants.js: «Ripristina la lista iniziale» rimette nel testo i domini predefiniti, uno per riga.
export default class extends Controller {
  static targets = ["testo"]
  static values = { predefiniti: Array }

  ripristina() {
    this.testoTarget.value = this.predefinitiValue.join("\n")
  }
}
